import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AccountRoleService } from 'auth/account-role.service';
import { UserRole } from 'generated/graphql';

/**
 * Add the template content to the DOM if user has at least the min role
 * passed
 */
// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[appIfMinRole]'})
export class IfMinRoleDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private accountRoleService: AccountRoleService,
    private viewContainer: ViewContainerRef) { }

  @Input() set appIfMinRole(role: UserRole) {
    const hasRole = this.accountRoleService.userHasMinRole(role);
    if (hasRole && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasRole && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
